import { CHARS_URDU } from "../../../lib";
import { autoComplete, eventEmitter } from "../../../services";
import { EVT_EDITOR_CONTENTS_SAVE } from "./index";
import { OrderedSet } from "immutable";

import {
    KEY_BACKSPACE,
    KEY_TAB,
    KEY_ENTER,
    KEY_PAUSE_BREAK,
    KEY_ESC,
    KEY_SPACE,
    KEY_PAGE_UP,
    KEY_PAGE_DOWN,
    KEY_END,
    KEY_HOME,
    KEY_LEFT_ARROW,
    KEY_RIGHT_ARROW,
    KEY_INSERT,
    KEY_DELETE,
    KEY_MULTIPLY,
    KEY_ADD,
    KEY_SUBTRACT,
    KEY_DECIMAL_POINT,
    KEY_DIVIDE,
} from "../../../lib";

export function getAutoCompleteList(contents: string) {
    const re = /[^\u0600-\u06FF]/gi;
    let result = contents.replace(re, " ");

    const reUnWantedChars1 = /[\u064B-\u066D]/gi;
    result = result.replace(reUnWantedChars1, " ");

    const reUnWantedChars2 = /[\u06D4-\u06FF]/gi;
    result = result.replace(reUnWantedChars2, " ");

    // filter out empty items
    const list = result
        .split(" ")
        .map((s) => s.replace("،", ""))
        .map((s) => s.replace(/\s/g, ""))
        .filter((s) => s.length >= 7);

    const unique: string[] = [];
    for (const s of new Set(list)) {
        unique.push(s);
    }
    return unique;
}

export function updateAutoCompleteList(set: OrderedSet<string>) {
    autoComplete.set(set);
}

const AUTOCOMPLETE_CANCEL_KEYS = [
    KEY_BACKSPACE,
    KEY_TAB,
    KEY_ENTER,
    KEY_PAUSE_BREAK,
    KEY_ESC,
    KEY_SPACE,
    KEY_PAGE_UP,
    KEY_PAGE_DOWN,
    KEY_END,
    KEY_HOME,
    KEY_LEFT_ARROW,
    KEY_RIGHT_ARROW,
    KEY_INSERT,
    KEY_DELETE,
    KEY_MULTIPLY,
    KEY_ADD,
    KEY_SUBTRACT,
    KEY_DECIMAL_POINT,
    KEY_DIVIDE,
];
export function isAutoCompleteCancelKey(key: string) {
    return AUTOCOMPLETE_CANCEL_KEYS.includes(key);
}

export function getWordForAutoComplete() {
    const sel = window.getSelection();
    if (!sel) {
        return;
    }

    if (sel.rangeCount) {
        const range = sel.getRangeAt(0);
        if (range.collapsed) {
            const { endContainer, endOffset } = range;
            const { nodeName, nodeValue } = endContainer;

            if (!nodeValue) {
                return;
            }

            if (nodeName === "#text") {
                let i = endOffset - 1;
                let arr = [];
                while (i >= 0 && CHARS_URDU.includes(nodeValue[i])) {
                    arr.unshift(nodeValue[i]);
                    i -= 1;
                }
                return arr.join("");
            }
        }
    }

    return "";
}

export function replaceAutoCompleteWord(fromWord: string, toWord: string) {
    const sel = window.getSelection();
    if (!sel) {
        return;
    }

    if (sel.rangeCount) {
        const range = sel.getRangeAt(0);
        if (range.collapsed) {
            const startOffset = range.endOffset - fromWord.length;

            if (!sel.focusNode) {
                return;
            }

            range.setStart(sel.focusNode, startOffset);
            range.setEnd(sel.focusNode, range.endOffset);
            range.deleteContents();

            const replaceNode = document.createTextNode(toWord);
            range.insertNode(replaceNode);

            const nextOffset = toWord.length;
            range.setStart(replaceNode, nextOffset);
            range.setEnd(replaceNode, nextOffset);

            const spaceNode = document.createTextNode("\u00A0");
            range.insertNode(spaceNode);
            range.setStart(spaceNode, 1);
            range.setEnd(spaceNode, 1);
        }
    }
}

export function saveEditorContents() {
    eventEmitter.emit(EVT_EDITOR_CONTENTS_SAVE);
}
